import Vue from 'vue'

/**
 * 获取考勤工作代码类型
 * @param {} params
 */
export const getWorkCodeType = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/findWorkCodeType', params)
}

/**
 * 获取考勤工作代码
 * @param {*} params
 */
export const findWorkCode = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/findWorkCode', params)
}

export const deleteWorkCodeType = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/deleteWorkCodeType', params)
}

export const saveOrUpdateWorkCode = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/saveOrUpdateWorkCode', params)
}

export const saveOrUpdateWorkCodeType = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/saveOrUpdateWorkCodeType', params)
}

export const batchDeleteWorkCode = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/batchDeleteWorkCode', params)
}

/**
 * 考勤工作代码类型获取设备列表
 * @param {
 *  "workCodeTypeId":""
 * } params
 */
export const findBindDeviceList = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/findBindDeviceList', params)
}

/**
 * 获取未绑定的设备列表
 * @param {
 * "workCodeTypeId":""
 * } params
 */
export const findUnbindDeviceList = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/findUnbindDeviceList', params)
}

/**
 * 绑定
 * @param {
 *  "workCodeTypeId":"",
 *  "deviceIds":["12","13"]
 * } params
 */
export const bindWorkCodeTypeToDevices = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/bindWorkCodeTypeToDevices', params)
}

/**
 * 解除绑定
 * @param {
 *  "workCodeTypeId":"",
 *  "deviceIds":["12","13"]
 * } params
 */
export const unbindWorkCodeTypeToDevices = (params) => {
  return Vue.fetch.post('/apiv1/hr/workcode/unbindWorkCodeTypeToDevices', params)
}



// WEBPACK FOOTER //
// ./src/services/workcodeApi.js